<template>
  <div class="application-page">
    <div class="application-content">
      <van-nav-bar
        :title="$t('applications.department.title')"
        left-arrow
        @click-left="$router.back()"
      />

      <div class="form-card department">
        <div class="form-header">
          <div class="form-icon">
<!--            <van-icon name="store" />-->
            <img src="../../assets/cooperation/brush.png"/>
          </div>
          <div>
            <h2 class="form-title">
              {{ $t('applications.department.title') }}
            </h2>
            <p class="form-subtitle">
              {{ $t('applications.department.subtitle') }}
            </p>
          </div>
        </div>

        <van-form
          class="application-form"
          @submit="handleSubmit"
        >
          <van-cell-group>
            <van-field
              v-model="formData.storeName"
              :label="$t('applications.department.storeName')"
              :placeholder="$t('applications.department.storeNamePlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />

            <van-field
              v-model="formData.groupName"
              :label="$t('applications.department.groupName')"
              :placeholder="$t('applications.department.groupNamePlaceholder')"
            />

            <div class="form-row">
              <van-field
                v-model="formData.country"
                :label="$t('applications.department.country')"
                :placeholder="$t('applications.department.countryPlaceholder')"
                required
                :rules="[{ required: true, message: $t('common.required') }]"
              />
              <van-field
                v-model="formData.city"
                :label="$t('applications.department.city')"
                :placeholder="$t('applications.department.cityPlaceholder')"
                required
                :rules="[{ required: true, message: $t('common.required') }]"
              />
            </div>

            <van-field
              v-model="formData.address"
              :label="$t('applications.department.address')"
              :placeholder="$t('applications.department.addressPlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />

            <van-field
              v-model="formData.storeLevel"
              :label="$t('applications.department.storeLevel')"
              is-link
              readonly
              required
              :rules="[{ required: true, message: $t('common.required') }]"
              @click="showStoreLevelPicker = true"
            />

            <div class="form-row">
              <van-field
                v-model="formData.businessArea"
                type="number"
                :label="$t('applications.department.businessArea')"
                :placeholder="$t('applications.department.businessAreaPlaceholder')"
                required
                :rules="[{ required: true, message: $t('common.required') }]"
              />
              <van-field
                v-model="formData.annualTraffic"
                type="number"
                :label="$t('applications.department.annualTraffic')"
                :placeholder="$t('applications.department.annualTrafficPlaceholder')"
                required
                :rules="[{ required: true, message: $t('common.required') }]"
              />
            </div>

            <van-field
              v-model="formData.existingBrands"
              :label="$t('applications.department.existingBrands')"
              type="textarea"
              autosize
              :placeholder="$t('applications.department.existingBrandsPlaceholder')"
              rows="2"
            />

            <van-field
              v-model="formData.cooperationDescription"
              :label="$t('applications.department.cooperationDescription')"
              type="textarea"
              autosize
              :placeholder="$t('applications.department.cooperationDescriptionPlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
              rows="3"
            />
          </van-cell-group>

          <div class="section-title">
            {{ $t('applications.contactInfo') }}
          </div>
          <van-cell-group>
            <van-field
              v-model="formData.contactName"
              :label="$t('applications.contactName')"
              :placeholder="$t('applications.contactNamePlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />

            <div class="form-row">
              <van-field
                v-model="formData.contactPosition"
                :label="$t('applications.contactPosition')"
                :placeholder="$t('applications.contactPositionPlaceholder')"
                required
                :rules="[{ required: true, message: $t('common.required') }]"
              />
              <van-field
                v-model="formData.contactPhone"
                type="tel"
                :label="$t('applications.contactPhone')"
                :placeholder="$t('applications.contactPhonePlaceholder')"
                required
                :rules="[{ required: true, message: $t('common.required') }]"
              />
            </div>

            <van-field
              v-model="formData.contactEmail"
              type="email"
              :label="$t('applications.contactEmail')"
              :placeholder="$t('applications.contactEmailPlaceholder')"
              required
              :rules="[{ required: true, message: $t('common.required') }]"
            />
          </van-cell-group>

          <div class="agreement-section">
            <van-checkbox
              v-model="agreeTerms"
              shape="square"
              required
            >
              {{ $t('applications.agreeTerms') }}
            </van-checkbox>
          </div>

          <div class="submit-section">
            <van-button
              round
              block
              type="primary"
              native-type="submit"
              :loading="submitting"
              class="submit-btn"
            >
              {{ $t('common.submit') }}
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

    <van-popup
      v-model:show="showStoreLevelPicker"
      position="bottom"
    >
      <van-picker
        :columns="storeLevelOptions"
        @confirm="onStoreLevelConfirm"
        @cancel="showStoreLevelPicker = false"
      />
    </van-popup>

    <van-overlay
      :show="submitting"
      class="submitting-overlay"
    >
      <div class="overlay-content">
        <van-loading
          size="24px"
          vertical
        >
          {{ $t('common.submitting') }}
        </van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { showToast, showSuccessToast } from 'vant'
import { departmentStoreApply } from '@/api/cooperation'

export default {
  name: 'DepartmentStore',
  setup () {
    const { t } = useI18n()
    const router = useRouter()

    // const formData = reactive({
    //   storeName: '百联',
    //   groupName: '',
    //   country: '中国',
    //   city: '上海',
    //   address: '上海市闵行区',
    //   storeLevel: '中高端',
    //   businessArea: '10000',
    //   annualTraffic: '50000000',
    //   existingBrands: '波司登、耐克等',
    //   cooperationDescription: '深度合作',
    //   contactName: '张',
    //   contactPosition: '销售经理',
    //   contactPhone: '18569693366',
    //   contactEmail: '123@123.com'
    // })
    const formData = reactive({
      storeName: '',
      groupName: '',
      country: '',
      city: '',
      address: '',
      storeLevel: '',
      businessArea: '',
      annualTraffic: '',
      existingBrands: '',
      cooperationDescription: '',
      contactName: '',
      contactPosition: '',
      contactPhone: '',
      contactEmail: ''
    })

    const submitting = ref(false)
    const agreeTerms = ref(false)
    const showStoreLevelPicker = ref(false)

    const storeLevelOptions = [
      { text: t('applications.department.storeLevelOptions.highEnd'), value: 'highEnd' },
      { text: t('applications.department.storeLevelOptions.midHigh'), value: 'midHigh' },
      { text: t('applications.department.storeLevelOptions.mass'), value: 'mass' }
    ]

    const onStoreLevelConfirm = ({ selectedOptions }) => {
      if (selectedOptions && selectedOptions.length > 0) {
        formData.storeLevel = selectedOptions[0].text
        showStoreLevelPicker.value = false
      }
    }

    const handleSubmit = async () => {
      if (!agreeTerms.value) {
        showToast(t('applications.agreeTermsRequired'))
        return
      }
      console.log('1111', formData)
      submitting.value = true
      departmentStoreApply(formData).then(res => {
        showSuccessToast(t('applications.submitSuccess'))
        submitting.value = false
        setTimeout(() => {
          router.back()
        }, 1500)
      }).catch(error => {
        showToast(t('common.submitFailed') + error.msg)
        submitting.value = false
      })

      // try {
      //   // 模拟API调用
      //   await new Promise(resolve => setTimeout(resolve, 2000))
      //
      //   // 这里应该调用实际的API
      //   // await submitDepartmentApplication(formData)
      //
      //   showSuccessToast(t('applications.submitSuccess'))
      //
      //   // 重置表单
      //   Object.keys(formData).forEach(key => {
      //     formData[key] = ''
      //   })
      //   agreeTerms.value = false
      //
      //   setTimeout(() => {
      //     router.back()
      //   }, 1500)
      // } catch (error) {
      //   showToast(t('common.submitFailed'))
      // } finally {
      //   submitting.value = false
      // }
    }

    return {
      formData,
      submitting,
      agreeTerms,
      showStoreLevelPicker,
      storeLevelOptions,
      onStoreLevelConfirm,
      handleSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.application-page {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.application-content {
  padding: 16px;
  //padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  //@media (min-width: 1200px) {
  //  max-width: 600px;
  //  margin: 0 auto;
  //  padding: 24px;
  //}
}

.form-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-top: 5px solid;
  margin-top: 16px;

  &.department {
    border-top-color: #10b981;
  }

  .form-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .form-icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: white;
      margin-right: 15px;
      background: #10b981;
      img{
        width: 30px;
        height: 30px;
      }
    }

    .form-title {
      font-size: 20px;
      font-weight: 600;
      color: #1e293b;
      margin: 0 0 4px;
    }

    .form-subtitle {
      font-size: 14px;
      color: #64748b;
      margin: 0;
    }
  }
}

.application-form {
  .form-row {
    display: flex;
    gap: 12px;

    :deep(.van-field) {
      flex: 1;
    }
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    margin: 24px 0 16px;
    padding-left: 16px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 16px;
      background: #3b82f6;
      border-radius: 2px;
    }
  }

  :deep(.van-cell-group) {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
  }

  :deep(.van-field) {
    padding: 12px 16px;

    .van-field__label {
      font-weight: 500;
      color: #374151;
    }
  }
}

.agreement-section {
  margin: 24px 0;
  padding: 0 16px;

  :deep(.van-checkbox) {
    align-items: flex-start;

    .van-checkbox__label {
      font-size: 14px;
      color: #64748b;
      line-height: 1.4;
    }
  }
}

.submit-section {
  margin-top: 32px;

  .submit-btn {
    height: 44px;
    font-size: 16px;
    font-weight: 500;
  }
}

.submitting-overlay {
  display: flex;
  align-items: center;
  justify-content: center;

  .overlay-content {
    text-align: center;
    color: white;
  }
}

/* 1080×1920 设备适配 */
@media (min-width: 1080px) {
  .application-content {
    padding: 32px;
  }

  .form-card {
    padding: 32px;
    margin-top: 24px;

    .form-header {
      margin-bottom: 32px;

      .form-icon {
        width: 80px;
        height: 80px;
        font-size: 32px;
      }

      .form-title {
        font-size: 24px;
      }

      .form-subtitle {
        font-size: 16px;
      }
    }
  }

  .application-form {
    :deep(.van-field) {
      padding: 16px 20px;

      .van-field__label {
        font-size: 18px;
      }

      .van-field__control {
        font-size: 18px;
      }
    }
  }

  .submit-section .submit-btn {
    height: 56px;
    font-size: 18px;
  }
}

/* PC端优化 */
@media (min-width: 1200px) {
  .application-page {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
  }

  .application-content {
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    width: 100%;
    //max-width: 600px;
    //margin: 40px auto;
  }

  .form-card {
    box-shadow: none;
    padding: 40px;
    margin-top: 0;
    border-radius: 0;
    border-top: none;
  }
}

/* 移动端适配 */
@media (max-width: 767px) {
  .application-content {
    padding: 12px;
  }

  .form-card {
    padding: 16px;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }
}
</style>
